import { useReactiveVar } from '@apollo/client';
import { featureCountryCode } from 'states/persistInStorage';
import { useAuthStore } from 'stores/authStore';
import { CountryCode } from 'types/generatedSchemaTypes';

const organizationNames: Record<CountryCode, string> = {
  FI: 'Aimo Park Finland Oy',
  NO: 'Aimo Park Norge AS',
  SE: 'Aimo Park Sweden AB',
};

const websiteUrls: Record<CountryCode, string> = {
  FI: 'https://www.aimopark.fi/',
  NO: 'https://www.aimopark.no/',
  SE: 'https://www.aimopark.se/',
};

const websiteLabels: Record<CountryCode, string> = {
  FI: 'www.aimopark.fi',
  NO: 'www.aimopark.no',
  SE: 'www.aimopark.se',
};

const useOrganizationCountry = (): CountryCode | null => {
  const currentCountry = useAuthStore((state) => state.currentCustomerCountry);
  const featureCountry = useReactiveVar(featureCountryCode);

  return featureCountry || currentCountry;
};

export const useOrganizationWebsite = () => {
  const country = useOrganizationCountry();

  return {
    url: country ? websiteUrls[country] : '',
    label: country ? websiteLabels[country] : '',
  };
};

const useOrganizationName = () => {
  const country = useOrganizationCountry();

  return country ? organizationNames[country] : '';
};

export default useOrganizationName;
